// extracted by mini-css-extract-plugin
module.exports = {"headerNav":"header-nav-module--header-nav--3UmDx","smallNavToggle":"header-nav-module--small-nav-toggle--10N9y"};